import { Flex, Heading, Spinner, Text } from '@chatsdet/ui';
import { useSystemAlertRule, useSaveSystemAlertRule } from '../../../features/scheduling/useSystemAlertRule.js';
import { AlertDestinationEditor } from '../../../features/test-suites/AlertDestinationEditor.js';

const SUITE_COMPLETED_EVENT = 'test_suite.completed';
const DESCRIPTION =
  'Every suite run in this organization — manual or scheduled — sends its results here. Each destination gets one alert per run, even if a suite or schedule also lists it.';

/** The org-wide suite-completion alert: one `system` / `test_suite.completed` notify rule. */
export function SuiteCompletionAlerts() {
  const ruleQuery = useSystemAlertRule(SUITE_COMPLETED_EVENT, true);
  const saveMutation = useSaveSystemAlertRule(SUITE_COMPLETED_EVENT, 'Suite completion alerts');
  const rule = ruleQuery.data ?? null;
  const alertConfig = rule?.alertConfig ?? { steps: [] };

  // Never offer a save until the rule is known: an errored lookup would read as "no rule yet" and create a duplicate.
  if (ruleQuery.isError) {
    return (
      <div className="space-y-1">
        <Heading level={2}>Suite completion alerts</Heading>
        <Text size="sm" className="text-destructive">
          {ruleQuery.error instanceof Error ? ruleQuery.error.message : 'Failed to load alerts'}
        </Text>
      </div>
    );
  }

  if (!ruleQuery.isSuccess) {
    return (
      <Flex align="center" justify="center" className="py-8">
        <Spinner size="lg" />
      </Flex>
    );
  }

  return (
    <AlertDestinationEditor
      title="Suite completion alerts"
      description={DESCRIPTION}
      alertConfig={alertConfig}
      isPending={saveMutation.isPending}
      onSave={async (next) => {
        await saveMutation.mutateAsync({ ruleId: rule?.id ?? null, alertConfig: next });
      }}
      headingLevel={2}
    />
  );
}
